/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import {
  EditCPBankAccount,
  PayerBankAccount,
  PayerBankAccountsSynchronization,
} from "@/models/api/administration/contractors/PayerBankAccountsSynchronization";
import {
  getPayerBankAccounts,
  postAddPayerBankAccount,
  postEditPayerBankAccount,
  postSyncPayerBankAccounts,
} from "@/requests/administration/contractors/contractorPayerBankAccounts";

export interface AdministrationContractorPayerBankAccountStateInterface {
  bankAccounts: Array<PayerBankAccount>;
  canSync: boolean;
  lastSync: string | null;
  selectedBankAccountId: null | number;
  editModel: EditCPBankAccount;
  isAddDialog: boolean;
}

export const AdministrationContractorPayerBankAccountState: AdministrationContractorPayerBankAccountStateInterface = {
  bankAccounts: [],
  canSync: false,
  lastSync: null,
  selectedBankAccountId: null,
  editModel: new EditCPBankAccount(),
  isAddDialog: false,
};

const AdministrationContractorPayerBankAccountModule = defineModule({
  state: AdministrationContractorPayerBankAccountState as AdministrationContractorPayerBankAccountStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setData(state, param: PayerBankAccountsSynchronization) {
      state.bankAccounts = param.bankAccounts;
      state.canSync = param.canSync;
      state.lastSync = param.lastSync;
    },
    setSelectedBankAccountId(state, param: number | null) {
      state.selectedBankAccountId = param;
    },
    setEditModel(state, param: EditCPBankAccount) {
      state.editModel = param;
    },
    setIsAddDialog(state, param: boolean) {
      state.isAddDialog = param;
    },
  },
  actions: {
    async downloadPayerBankAccounts(context) {
      const { rootState, commit } = _moduleActionContext(context);
      if (rootState.administration.contractors.list.selectedContractorId) {
        const model = await getPayerBankAccounts(rootState.administration.contractors.list.selectedContractorId);
        commit.setData(model);
      }
    },
    async addPayerBankAccount(context, param: EditCPBankAccount) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (rootState.administration.contractors.list.selectedContractorId)
        await postAddPayerBankAccount(rootState.administration.contractors.list.selectedContractorId, param);
    },
    async editPayerBankAccount(context) {
      const { rootDispatch, state } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (state.selectedBankAccountId) await postEditPayerBankAccount(state.selectedBankAccountId, state.editModel);
    },
    async syncPayerBankAccounts(context) {
      const { rootState, rootDispatch, state, dispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (rootState.administration.contractors.list.selectedContractorId && state.canSync) {
        await postSyncPayerBankAccounts(rootState.administration.contractors.list.selectedContractorId);
        await dispatch.downloadPayerBankAccounts();
      }
    },
  },
});

export default AdministrationContractorPayerBankAccountModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AdministrationContractorPayerBankAccountModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationContractorPayerBankAccountModule);
